import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  text: {
    color: token.colorPrimary,

    a: {
      color: `${token.colorPrimary} !important`
    },
    svg: {
      marginTop: '5px !important'
    }
  }
}))
